import { ObservableArray, View } from "binder"
import { CustomerSearchViewModel } from "src/erp/arap/rawData/customerSelector-viewModel";
import { CustomerTurnOverViewModel, lineItem } from "./customerTurnOver-viewModel"

export class CustomerTurnOverView extends View<CustomerTurnOverViewModel>{
    GetViewUniqueId(): string {
        return "V-977B7A8E-F905-4CAD-94FE-F36A46A16F1E"
    }
    loadHtml(): string {
        let element = require('./customerTurnOver.html').default;
        let style = require('./customerTurnOver.less');
        return element;
    }
    constructor() {
       super();
    }
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set customerSelector(v: CustomerSearchViewModel) { this._customerSelector = v; } public get customerSelector(): CustomerSearchViewModel { return this._customerSelector;} private _customerSelector: CustomerSearchViewModel;
    
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode;} private _customerCode: string;
    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;
    public set remaining(v: string) { this._remaining = v; } public get remaining(): string { return this._remaining;} private _remaining: string;
    
    calculate(){
        this.dataContext.calculate();
    }
}
